module.exports = __webpack_public_path__ + "static/img/8.3521510.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/1/eng/8.png
// module id = RRHP
// module chunks = 0